import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import useGetParamsData from "./useGetParamsData";

const useQueryTable = ({ queryList = ["page"], url }) => {
  const navigate = useNavigate();
  const location = useLocation();

  // Parse the current query params from the URL
  const queryParams = new URLSearchParams(location.search);

  const [searchValues, setSearchValues] = useState(
    queryList.reduce((acc, curr) => {
      if (curr === "page") acc[curr] = Number(queryParams.get("page")) || 1;
      else acc[curr] = queryParams.get(curr) || "";
      return acc;
    }, {})
  );

  const { isError, isLoading, data } = useGetParamsData(
    queryParams.toString(),
    url
  );

  if (isError) console.log({ error: isError });

  // Update query params when search values or current page change
  useEffect(() => {
    const updatedParams = new URLSearchParams();

    Object.keys(searchValues).forEach((key) => {
      if (searchValues[key]) {
        updatedParams.set(key, searchValues[key]);
      }
    });

    // Update the URL with the new search parameters
    navigate({ search: updatedParams.toString() });
  }, [searchValues, navigate]);

  const moreData = data?.data?.info?.more_records;
  const totalData = data?.data?.countVal;
  // console.log({
  //   moreData,
  //   totalPage: searchValues.page + (moreData ? 1 : 0),
  // });

  return [isLoading, data, searchValues, setSearchValues, moreData, totalData];
};

export default useQueryTable;
